// Party Trivia / Quiz Mania Client
import { sounds } from '../sound.js';

export class TriviaGameClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.hasAnswered = false;

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="trivia-wrapper">
        <div class="trivia-header">
          <div class="trivia-meta">
            <span id="trivia-round-badge" class="trivia-badge">QUESTION 1 / 5</span>
            <span id="trivia-cat-badge" class="trivia-cat">Topic: Loading...</span>
          </div>
          <div id="trivia-timer" class="trivia-timer">⏳ 10s</div>
        </div>

        <!-- Topic Choice Modal for Host -->
        <div id="trivia-topic-modal" class="trivia-topic-modal modal-hidden">
          <h3>👑 CHOOSE QUIZ TOPIC</h3>
          <div class="topic-grid" id="trivia-topic-grid"></div>
        </div>

        <!-- Question Card -->
        <div class="trivia-q-box">
          <h2 id="trivia-q-text" class="trivia-q-text">Host is choosing a topic...</h2>
        </div>

        <!-- 4 Multi-Choice Options -->
        <div class="trivia-options-grid" id="trivia-options-grid"></div>

        <!-- Live Scores Leaderboard -->
        <div class="trivia-scores-row" id="trivia-scores-row"></div>
      </div>
    `;
  }

  setupSocketEvents() {
    this.socket.on('trivia_selectTopicPrompt', (data) => {
      const modal = document.getElementById('trivia-topic-modal');
      const grid = document.getElementById('trivia-topic-grid');
      if (modal && grid) {
        grid.innerHTML = '';
        data.categories.forEach((cat) => {
          const btn = document.createElement('button');
          btn.className = 'btn-topic-opt';
          btn.innerText = cat.name;
          btn.addEventListener('click', () => {
            sounds.playPop();
            this.socket.emit('trivia_chooseCategory', { category: cat.id });
            modal.classList.add('modal-hidden');
          });
          grid.appendChild(btn);
        });
        modal.classList.remove('modal-hidden');
      }
    });

    this.socket.on('trivia_waitingTopic', (data) => {
      const qText = document.getElementById('trivia-q-text');
      if (qText) qText.innerText = `Waiting for Host (${data.hostName}) to select a quiz topic...`;
    });

    this.socket.on('trivia_newQuestion', (data) => {
      this.hasAnswered = false;
      sounds.playChime();

      const modal = document.getElementById('trivia-topic-modal');
      if (modal) modal.classList.add('modal-hidden');

      const rBadge = document.getElementById('trivia-round-badge');
      const catBadge = document.getElementById('trivia-cat-badge');
      const qText = document.getElementById('trivia-q-text');
      const grid = document.getElementById('trivia-options-grid');

      if (rBadge) rBadge.innerText = `QUESTION ${data.round} / ${data.total}`;
      if (catBadge) catBadge.innerText = `Topic: ${data.category}`;
      if (qText) qText.innerText = data.question;

      if (grid) {
        grid.innerHTML = '';
        data.options.forEach((opt, idx) => {
          const btn = document.createElement('button');
          btn.className = 'btn-trivia-opt';
          btn.innerHTML = `<span class="opt-letter">${['A', 'B', 'C', 'D'][idx]}</span> <span>${opt}</span>`;
          btn.addEventListener('click', () => {
            if (!this.hasAnswered) {
              this.hasAnswered = true;
              sounds.playPop();
              grid.querySelectorAll('.btn-trivia-opt').forEach(b => b.classList.remove('selected'));
              btn.classList.add('selected');
              this.socket.emit('trivia_answer', { choiceIndex: idx });
            }
          });
          grid.appendChild(btn);
        });
      }
    });

    this.socket.on('trivia_tick', (data) => {
      const timer = document.getElementById('trivia-timer');
      if (timer) timer.innerText = `⏳ ${data.timer}s`;
    });

    this.socket.on('trivia_answerReveal', (data) => {
      const grid = document.getElementById('trivia-options-grid');
      if (grid) {
        const buttons = grid.querySelectorAll('.btn-trivia-opt');
        buttons.forEach((btn, idx) => {
          if (idx === data.correctIndex) {
            btn.classList.add('correct');
          } else if (btn.classList.contains('selected')) {
            btn.classList.add('wrong');
          }
        });
      }

      const scoresRow = document.getElementById('trivia-scores-row');
      if (scoresRow && data.scores) {
        scoresRow.innerHTML = data.scores.map(p => `
          <div class="trivia-p-score">
            <span>${p.avatar} ${p.name}</span>
            <span class="pts">⭐ ${p.score}</span>
          </div>
        `).join('');
      }
    });

    this.socket.on('trivia_gameOver', (data) => {
      sounds.playVictory();
      const top = data.leaderboard[0];
      alert(`🏆 TRIVIA MASTER: ${top?.name || 'Player'} won with ${top?.score || 0} points!`);
    });
  }

  destroy() {
    this.socket.off('trivia_selectTopicPrompt');
    this.socket.off('trivia_waitingTopic');
    this.socket.off('trivia_newQuestion');
    this.socket.off('trivia_tick');
    this.socket.off('trivia_answerReveal');
    this.socket.off('trivia_gameOver');
  }
}
